export const posts = [
  {
    id: "emoji-1",
    category: "biaoqingbao",
    title: "吃瓜群众一秒上线表情包合集",
    excerpt: "手里的瓜子还没嗑完，人已经坐到了第一排。这套表情包专治群里消息太多，一次囤够。",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20flat%20vector%20illustration%20of%20a%20cute%20cartoon%20crowd%20holding%20watermelon%20slices%20and%20popcorn%20while%20watching%20a%20glowing%20screen%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-1&orientation=landscape",
    tags: ["吃瓜", "群聊", "高频使用"],
    author: "吃瓜小分队",
    date: "2026-09-08",
    views: 48210,
    likes: 3260,
    commentCount: 128,
    body: [
      "群里一有热闹，最先冲上去的永远是那批「瓜田常驻嘉宾」。这套表情包把吃瓜群众的经典姿态做成了 12 张不同情绪，从「正在赶来的路上」到「我先坐下」，一套图就能把整场热闹演出。",
      "使用建议：看到长段落消息时发「慢慢说，我在听」；看到反转剧情时发「手里的瓜突然不香了」；看到收尾时发「散了吧，明天再说」。收藏后记得建一个专属相册，斗图时能省下宝贵的三秒。",
    ],
  },
  {
    id: "emoji-2",
    category: "biaoqingbao",
    title: "捂脸笑表情包：今夏群里出现频率最高",
    excerpt: "一个捂脸，胜过十句「哈哈哈」。这套表情专门解决不知道回什么的尴尬时刻。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20big%20cheerful%20face%20covering%20its%20mouth%20with%20one%20hand%20and%20laughing%2C%20chat%20bubbles%20floating%20around%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-2&orientation=landscape",
    tags: ["捂脸笑", "万能回复", "表情包"],
    author: "梗王本王",
    date: "2026-09-06",
    views: 39980,
    likes: 2870,
    commentCount: 96,
    body: [
      "有没有一种时刻，别人发来的消息你看了想笑又不知道怎么接？这时候发一个捂脸笑，礼貌、得体、还带着一点心照不宣，几乎不会出错。",
      "这套表情共 9 张，分「尴尬捂脸」「佩服捂脸」「无语捂脸」「被夸捂脸」四类情绪。建议按情绪分文件夹存好，群聊里直接调取，比临时找图快得多。",
    ],
  },
  {
    id: "emoji-3",
    category: "biaoqingbao",
    title: "群聊斗图必备：手机对轰系列",
    excerpt: "两部手机表情包互相砸过去，谁先没有存货谁先认输。斗图党的弹药库来了。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20two%20smartphones%20facing%20each%20other%20with%20funny%20sticker%20faces%20popping%20out%20during%20a%20chat%20battle%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-3&orientation=landscape",
    tags: ["斗图", "群聊", "手机"],
    author: "深夜冲浪选手",
    date: "2026-09-04",
    views: 35640,
    likes: 2410,
    commentCount: 74,
    body: [
      "斗图讲究的是节奏：对方发一张，你必须在一秒内回一张，气势不能断。所以真正的斗图高手，手机里永远备着一个「武器库」文件夹。",
      "这一系列共 15 张，画风统一、尺寸一致，连续发出来会形成奇妙的连贯感。小技巧：把最狠的那三张放在相册最后，关键时刻再掏出来，效果翻倍。",
    ],
  },
  {
    id: "emoji-4",
    category: "biaoqingbao",
    title: "打工人的 emo 图腾表情包",
    excerpt: "咖啡见底、会议未完、周报待写。这套表情是打工人每日情绪的精准画像。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20tired%20office%20worker%20slumped%20over%20a%20desk%20with%20coffee%20cups%20and%20floating%20emotion%20symbols%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-4&orientation=landscape",
    tags: ["打工人", "职场", "emo"],
    author: "乐子研究所",
    date: "2026-09-02",
    views: 52730,
    likes: 3905,
    commentCount: 152,
    body: [
      "周一早上打开电脑的那一瞬间，情绪是复杂的。这一套表情把打工人一周的心情拆成了五张：周一硬撑、周二麻木、周三谷底、周四回血、周五飘起来。",
      "用法很直接：在同事群里按当天日期发对应的那一张，不用配文字，大家都懂。周五那张尤其抢手，建议提前预定。",
    ],
  },
  {
    id: "emoji-5",
    category: "biaoqingbao",
    title: "猫咪叹气表情包：温柔又好笑",
    excerpt: "一只圆滚滚的猫叹了口气，什么话都没说，但什么都说了。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20round%20fluffy%20cat%20sighing%20with%20a%20tiny%20thought%20cloud%20above%20its%20head%2C%20cozy%20mood%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-5&orientation=landscape",
    tags: ["猫咪", "治愈", "表情包"],
    author: "吃瓜小分队",
    date: "2026-08-31",
    views: 41320,
    likes: 3120,
    commentCount: 88,
    body: [
      "猫的表情天生自带情绪张力，叹气的时候尤其好笑——明明什么都没说，却把「我尽力了」表达得淋漓尽致。",
      "这组图适合发给同样在加班的同事、深夜还在改稿的朋友，以及那个总说「马上就好」的人。配文建议只用一个字：「唉」。",
    ],
  },
  {
    id: "emoji-6",
    category: "biaoqingbao",
    title: "晚安党专用表情包，睡前发一张就够了",
    excerpt: "月亮打卡、手机入被窝、明天再说。晚安党也有自己的仪式感。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20sleepy%20moon%20and%20a%20little%20star%20tucking%20a%20phone%20into%20bed%2C%20peaceful%20night%20scene%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-emoji-6&orientation=landscape",
    tags: ["晚安", "睡前", "治愈"],
    author: "神评收集官",
    date: "2026-08-28",
    views: 29840,
    likes: 2050,
    commentCount: 63,
    body: [
      "群里聊到半夜，总得有个人说「睡了睡了」。与其打字，不如直接甩一张月亮抱着手机进被窝的表情，收尾得干净利落。",
      "这组共 6 张，从「马上睡」到「已经睡着」，语气依次递进。深夜发出去，第二天早上还能当早安表情接着用。",
    ],
  },
  {
    id: "joke-1",
    category: "duanzi",
    title: "周一早上的我和闹钟，谁也没赢",
    excerpt: "闹钟响到第七次，我开始认真思考它存在的意义。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20an%20angry%20alarm%20clock%20being%20grabbed%20by%20a%20sleepy%20hand%20in%20a%20messy%20bedroom%20morning%20scene%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-1&orientation=landscape",
    tags: ["周一", "起床", "打工人"],
    author: "乐子研究所",
    date: "2026-09-07",
    views: 61420,
    likes: 4380,
    commentCount: 210,
    body: [
      "我把闹钟设在了 7:00，闹钟把我叫醒在 7:00，我们都很守时。只是我躺在床上，认真思考了一下：既然每次都要按掉它，那它到底是在帮我，还是在给我制造一种被叫醒的错觉？",
      "后来我换了个思路，把闹钟改名叫「提醒你还可以再睡五分钟」。从那天起，我跟闹钟和解了，只是上班迟到的次数没什么变化。",
    ],
  },
  {
    id: "joke-2",
    category: "duanzi",
    title: "相亲现场的神展开，聊到第三句就笑了",
    excerpt: "对面问我有什么爱好，我说喜欢下班，他愣了一下说有品位。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20two%20people%20sitting%20awkwardly%20across%20a%20small%20table%20with%20tea%20cups%20and%20floating%20speech%20bubbles%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-2&orientation=landscape",
    tags: ["相亲", "对话", "段子"],
    author: "群众甲乙丙",
    date: "2026-09-05",
    views: 47380,
    likes: 3510,
    commentCount: 167,
    body: [
      "朋友去相亲，对面问：「你平时有什么爱好？」他想了想说：「下班。」对面沉默两秒，说：「品位不错，我也喜欢。」然后两个人聊了整整两个小时怎么拒绝加班。",
      "后来他们没成，因为一个想周末躺平，一个想周末爬山。朋友说这很正常，爱好可以不同，但对下班的热爱必须一致。",
    ],
  },
  {
    id: "joke-3",
    category: "duanzi",
    title: "外卖备注能有多离谱，骑手都沉默了",
    excerpt: "「麻烦不要放香菜，我上辈子是香菜。」这条备注我真的笑出声。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20takeout%20bag%20and%20a%20receipt%20surrounded%20by%20funny%20handwritten%20doodles%20and%20chopsticks%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-3&orientation=landscape",
    tags: ["外卖", "备注", "日常"],
    author: "梗王本王",
    date: "2026-09-03",
    views: 43910,
    likes: 3205,
    commentCount: 141,
    body: [
      "有人在外卖备注里写：「不要香菜，我是香菜过敏体质，不是挑食，是命运。」还有人写：「如果可以，请让米饭多一点，我今天很需要被安慰。」骑手看了大概会沉默三秒。",
      "最妙的一条是：「不用敲门，放门口就行，我们之间保持一点神秘感。」看起来点外卖也可以很有仪式感，只是饭凉得也快。",
    ],
  },
  {
    id: "joke-4",
    category: "duanzi",
    title: "妈妈的逻辑永远不会输，我服了",
    excerpt: "我说冷，她说多穿点；我穿多了说热，她说早就让你别穿。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20mother%20figure%20pointing%20at%20a%20laundry%20basket%20while%20a%20teenager%20hides%20behind%20a%20sofa%20cushion%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-4&orientation=landscape",
    tags: ["妈妈", "家庭", "日常"],
    author: "吃瓜小分队",
    date: "2026-09-01",
    views: 55160,
    likes: 4160,
    commentCount: 189,
    body: [
      "我妈的逻辑是这样的：我不收拾房间，她说「你这样以后怎么独立生活」；我收拾了，她说「你看你平时就不知道保持」。总之结论只有一个，那就是我确实该听她的。",
      "上周我试图反驳一次，说「每个人有自己的节奏」。她回：「对，所以你的节奏是慢半拍。」我认真想了想，竟然找不出毛病。",
    ],
  },
  {
    id: "joke-5",
    category: "duanzi",
    title: "打工人周报文学：把摸鱼写成项目管理",
    excerpt: "本周主要产出：完成了「在工位静坐」的长期观测项目。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20an%20open%20laptop%20on%20a%20desk%20with%20an%20absurdly%20long%20weekly%20report%20scroll%20spilling%20onto%20the%20floor%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-5&orientation=landscape",
    tags: ["周报", "打工人", "职场"],
    author: "深夜冲浪选手",
    date: "2026-08-30",
    views: 58240,
    likes: 4520,
    commentCount: 233,
    body: [
      "同事的周报我愿称之为艺术：「本周深度参与了跨部门沟通协作，输出关键决策支持，并对下阶段工作进行了前瞻性布局。」翻译过来大概是：开了三次会，发了两封邮件，剩下时间在等消息。",
      "当然，真正的高手不会写得这么虚。他们会写：「优化了日常流程中的无效环节」——也就是把三张表格合并成一张。字数少了，但气质上去了。",
    ],
  },
  {
    id: "joke-6",
    category: "duanzi",
    title: "地铁里的一句名言，我记了一整个月",
    excerpt: "广播说「请给需要帮助的乘客让座」，旁边小孩说了一句让我沉默的话。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20crowded%20subway%20car%20with%20one%20glowing%20speech%20bubble%20rising%20above%20the%20commuters%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-joke-6&orientation=landscape",
    tags: ["地铁", "通勤", "日常"],
    author: "神评收集官",
    date: "2026-08-27",
    views: 33760,
    likes: 2480,
    commentCount: 102,
    body: [
      "早高峰的地铁上，广播一遍遍提醒「请给需要帮助的乘客让座」。旁边一个小男孩拉了拉妈妈的衣服，认真地说：「妈妈，那大家是不是都很需要帮助？」车厢里好几个人都笑了。",
      "那一刻我突然觉得，通勤虽然挤，但偶尔也会挤出一句让人记很久的话。后来每次站上去，我都会想起这句，然后默默抓紧扶手。",
    ],
  },
  {
    id: "reply-1",
    category: "shenhuifu",
    title: "老板问为什么迟到，这回答我给满分",
    excerpt: "「路上遇到点意外。」「什么意外？」「闹钟意外地没叫我。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20boss%20figure%20with%20raised%20eyebrows%20facing%20a%20calm%20employee%20holding%20a%20broken%20alarm%20clock%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-1&orientation=landscape",
    tags: ["职场", "神回复", "迟到"],
    author: "神评收集官",
    date: "2026-09-08",
    views: 72150,
    likes: 5630,
    commentCount: 318,
    body: [
      "老板：「今天怎么又晚了？」员工：「路上遇到点意外。」老板：「什么意外？」员工：「闹钟意外地没响。」老板沉默了一下说：「这个意外挺稳定，每天都发生。」",
      "评论区补充了更高级的版本：「我不是迟到，我是把上班时间调成了弹性制，只不过今天弹得比较远。」当然，这句话说出来之前请先确认老板的心情。",
    ],
  },
  {
    id: "reply-2",
    category: "shenhuifu",
    title: "被夸年轻怎么回？网友的答案太稳了",
    excerpt: "「你看起来好年轻。」「谢谢，我保养的秘诀是少说话多睡觉。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20blushing%20person%20surrounded%20by%20compliment%20speech%20bubbles%20and%20a%20mirror%20with%20sparkles%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-2&orientation=landscape",
    tags: ["夸赞", "神回复", "社交"],
    author: "群众甲乙丙",
    date: "2026-09-06",
    views: 48920,
    likes: 3740,
    commentCount: 176,
    body: [
      "被夸年轻是个技术活：回「哪有哪有」显得太谦虚，回「我本来就年轻」又有点硬。高赞回答是：「谢谢，主要是心态好，气人的事都让别人去干。」",
      "还有一条更稳的：「我保养的秘诀是少说话多睡觉。」既把对方的夸奖收下了，又顺手立了一个「作息规律」的人设，堪称社交满分答案。",
    ],
  },
  {
    id: "reply-3",
    category: "shenhuifu",
    title: "室友半夜唱歌，这条回复终结了整场争论",
    excerpt: "「你能不能小声点？」「我已经很努力了，是歌太大声。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20dorm%20room%20at%20night%20with%20a%20microphone%20silhouette%20and%20a%20sleeping%20roommate%20covering%20ears%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-3&orientation=landscape",
    tags: ["室友", "宿舍", "神回复"],
    author: "乐子研究所",
    date: "2026-09-04",
    views: 39680,
    likes: 2890,
    commentCount: 121,
    body: [
      "凌晨一点，室友在唱歌。我说：「你能不能小声点？」他停下来认真想了想，回答：「我已经很努力了，主要是歌本身太大声。」这段对话让我们全宿舍笑到彻底睡不着。",
      "后来我们定了个规矩：想唱可以，但必须用「对方能听清歌词」的音量作为上限。第二天他改唱了儿歌，我们反而觉得挺好听的。",
    ],
  },
  {
    id: "reply-4",
    category: "shenhuifu",
    title: "客服的教科书级回答，我截图收藏了",
    excerpt: "「这个能便宜点吗？」「亲，价格不能便宜，但服务可以加倍。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20customer%20service%20headset%20floating%20above%20a%20crisp%20checklist%20and%20a%20perfect%20speech%20bubble%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-4&orientation=landscape",
    tags: ["客服", "神回复", "购物"],
    author: "梗王本王",
    date: "2026-09-02",
    views: 35410,
    likes: 2560,
    commentCount: 94,
    body: [
      "我问客服：「这个能便宜点吗？」客服回：「亲，价格不能便宜，但服务可以加倍。」我愣了一下，觉得这话说得实在漂亮，最后不但没砍价，还顺手加购了一件。",
      "还有一次我问发货时间，对方回：「已经在奔向你的路上了，只是路上有点堵。」这种回答虽然没给具体时间，但让我莫名觉得包裹真的在努力。",
    ],
  },
  {
    id: "reply-5",
    category: "shenhuifu",
    title: "亲戚催婚怎么接？网友这招太优雅了",
    excerpt: "「你什么时候结婚？」「等您家孩子先结，我好跟着学习经验。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20family%20gathering%20table%20with%20teacups%20and%20a%20young%20person%20slipping%20away%20from%20relatives%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-5&orientation=landscape",
    tags: ["催婚", "亲戚", "社交"],
    author: "吃瓜小分队",
    date: "2026-08-31",
    views: 66890,
    likes: 5120,
    commentCount: 287,
    body: [
      "过年最怕的一句话就是「你什么时候结婚」。有位网友的回答被顶上了热评：「等您家孩子先结，我好跟着学习经验。」一句话把话题优雅地送了出去，还顺便夸了对方。",
      "也有人走温和路线：「我在等一个像您这么会关心人的人出现。」长辈听完笑了半天，再也没提第二次。方法不分好坏，管用就行。",
    ],
  },
  {
    id: "reply-6",
    category: "shenhuifu",
    title: "同学群发广告，这条回复让群里安静了三秒",
    excerpt: "「打个广告，打扰了。」「不打扰，你继续，我们假装没看见。」",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20group%20chat%20screen%20with%20an%20advertising%20banner%20being%20covered%20by%20a%20playful%20mute%20symbol%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-reply-6&orientation=landscape",
    tags: ["同学群", "广告", "神回复"],
    author: "神评收集官",
    date: "2026-08-29",
    views: 32180,
    likes: 2340,
    commentCount: 87,
    body: [
      "同学群里一年到头都很安静，直到有人发了一句「打个广告，打扰了」。紧接着有人回：「不打扰，你继续，我们假装没看见。」群里安静了三秒，然后炸出一串「哈哈哈」。",
      "神奇的是，那位发广告的同学真没再发第二条，只是在群里发了个红包，备注写着「谢谢大家配合」。气氛反而比之前热络了。",
    ],
  },
  {
    id: "meme-1",
    category: "gengtu",
    title: "上班摸鱼时间管理大师梗图",
    excerpt: "把一天的八个时间段安排得明明白白，只是没有一段是工作。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20person%20daydreaming%20at%20a%20desk%20while%20tiny%20clocks%20and%20schedules%20float%20around%20like%20a%20puzzle%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-1&orientation=landscape",
    tags: ["摸鱼", "打工人", "梗图"],
    author: "深夜冲浪选手",
    date: "2026-09-07",
    views: 47620,
    likes: 3480,
    commentCount: 158,
    body: [
      "这张梗图把一天拆成了八个格子：9:00 到岗缓冲、10:00 找点灵感、11:00 思考午饭、14:00 消化午饭、15:00 找点灵感（第二次）、16:00 准备收尾、17:00 收尾、17:30 收尾冲刺。看起来非常充实。",
      "评论区有人补充：「最忙的时候是 17:29，因为要在一分钟内完成今天所有的工作。」这张图适合设置成电脑壁纸，每天提醒自己效率还有提升空间。",
    ],
  },
  {
    id: "meme-2",
    category: "gengtu",
    title: "一到交房租就艺术梗图",
    excerpt: "钱包空了，但气质还在，这就是大城市生活的浪漫。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20an%20empty%20wallet%20and%20a%20rent%20envelope%20on%20a%20table%20with%20dramatic%20spotlight%20and%20confetti%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-2&orientation=landscape",
    tags: ["房租", "生活", "梗图"],
    author: "乐子研究所",
    date: "2026-09-05",
    views: 41250,
    likes: 2960,
    commentCount: 119,
    body: [
      "每个月总有那么一天，钱包会举行一场盛大的告别仪式，主角是房租，观众是自己。梗图把这一刻拍得很有仪式感：灯光打下，信封一放，气质立刻上来了。",
      "有网友评论：「钱没了可以再赚，但如果这个月不交，下个月就要交两份。」一句话把浪漫拉回了现实，也让这张图更好笑了。",
    ],
  },
  {
    id: "meme-3",
    category: "gengtu",
    title: "减肥第一天，我点了一份沙拉和两个鸡腿",
    excerpt: "计划很完美，执行很有弹性，这就是成年人。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20salad%20bowl%20next%20to%20a%20giant%20cupcake%20with%20an%20arrow%20pointing%20the%20wrong%20way%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-3&orientation=landscape",
    tags: ["减肥", "美食", "梗图"],
    author: "吃瓜小分队",
    date: "2026-09-03",
    views: 39140,
    likes: 2870,
    commentCount: 133,
    body: [
      "减肥第一天，我郑重地给自己点了一份沙拉，然后觉得只吃草太苦了，又加了两个鸡腿补充蛋白质。逻辑是通的，只是热量不太同意。",
      "评论区的总结非常精准：「减肥最重要的不是吃什么，而是心理上先瘦下来。」这句话让我心安理得地把晚饭吃完了。",
    ],
  },
  {
    id: "meme-4",
    category: "gengtu",
    title: "凌晨三点的购物车，比白天更有想法",
    excerpt: "白天觉得不需要的东西，半夜看起来都闪着光。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20glowing%20phone%20at%20three%20am%20with%20a%20cart%20full%20of%20random%20items%20floating%20out%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-4&orientation=landscape",
    tags: ["购物车", "深夜", "梗图"],
    author: "梗王本王",
    date: "2026-09-01",
    views: 36780,
    likes: 2640,
    commentCount: 108,
    body: [
      "深夜的购物车有一种魔力：白天看了毫无感觉的东西，凌晨三点再看，全都顺眼。第二天早上清醒过来，只会感叹昨晚的自己怎么这么有购买欲。",
      "最保险的办法是设置一个「睡一觉再决定」的规则。实测有效，只是偶尔会有商品在购物车里下架，然后让人产生一种错失良机的遗憾。",
    ],
  },
  {
    id: "meme-5",
    category: "gengtu",
    title: "周一综合征梗图合集，看一眼就懂了",
    excerpt: "日历上写着周一，身体里写着「再来一天好不好」。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20gloomy%20monday%20cloud%20over%20a%20calendar%20with%20a%20tiny%20sun%20hiding%20in%20the%20corner%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-5&orientation=landscape",
    tags: ["周一", "日历", "梗图"],
    author: "神评收集官",
    date: "2026-08-30",
    views: 42960,
    likes: 3180,
    commentCount: 145,
    body: [
      "周一早上最真实的状态，大概是日历上明明写着「新的一周」，脑子却还停留在周日晚上那顿宵夜。梗图用一朵乌云和躲在角落的小太阳，把这种反差表达得恰到好处。",
      "有人说治周一综合征的办法是周日晚上早点睡，也有人说是周一早上给自己买一杯好喝的。实测第二个方法见效更快，只是钱包不太高兴。",
    ],
  },
  {
    id: "meme-6",
    category: "gengtu",
    title: "夏天的快乐很简单梗图",
    excerpt: "一把遮阳伞、一杯冷饮、一双拖鞋，就是一个完整的周末。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20beach%20umbrella%2C%20cold%20drink%20and%20flip%20flops%20arranged%20in%20a%20happy%20summer%20still%20life%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-meme-6&orientation=landscape",
    tags: ["夏天", "周末", "治愈"],
    author: "乐子研究所",
    date: "2026-08-28",
    views: 33520,
    likes: 2410,
    commentCount: 92,
    body: [
      "夏天让人开心的东西其实不多：一杯加满冰的饮料、一把撑得住的遮阳伞、一双走哪都凉快的拖鞋。梗图把这三样摆在一起，看着就觉得凉爽。",
      "有网友补充：「再加一个不用出门的下午，就是满分夏日。」这条评论获得了很多赞，大概是因为大家都懂那种「躺着最凉快」的道理。",
    ],
  },
  {
    id: "video-1",
    category: "shipin",
    title: "方言配音大赏：同一段台词六种口音",
    excerpt: "同一句话，换个方言就完全变了个味道，最后一个最好笑。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20microphone%20and%20colorful%20sound%20waves%20with%20a%20map%20of%20dialects%20drawn%20in%20the%20background%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-1&orientation=landscape",
    tags: ["方言", "配音", "二创"],
    author: "二创工作室",
    date: "2026-09-08",
    views: 88420,
    likes: 6710,
    commentCount: 402,
    body: [
      "同一句「你先别急，听我解释」，用六种方言说出来，情绪完全不一样：有的像在讲道理，有的像在下最后通牒，还有的说完自己先笑了。",
      "视频里还加入了字幕对照，非本地观众也能看懂笑点。评论区已经有人在催更第二期了，呼声最高的是东北话和四川话的 PK。",
    ],
  },
  {
    id: "video-2",
    category: "shipin",
    title: "名场面一镜到底混剪，节奏感拉满",
    excerpt: "三分钟剪进二十个经典瞬间，卡点准到让人想再看一遍。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20film%20clapperboard%20and%20a%20spotlight%20beam%20cutting%20across%20a%20minimal%20stage%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-2&orientation=landscape",
    tags: ["混剪", "卡点", "二创"],
    author: "深夜冲浪选手",
    date: "2026-09-06",
    views: 76230,
    likes: 5480,
    commentCount: 356,
    body: [
      "这条混剪的厉害之处在于节奏：每一个转场都刚好落在鼓点上，情绪的起承转合也被剪得清清楚楚，三分钟看完像是坐了一趟过山车。",
      "作者在简介里说，光是把素材对齐音乐就花了两个通宵。评论区有人感叹：「原来我以为的随手剪，背后是真的熬。」",
    ],
  },
  {
    id: "video-3",
    category: "shipin",
    title: "把评论区神回复配成音，笑点翻倍",
    excerpt: "文字看着好笑，念出来更好笑，配上背景音直接封神。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20comment%20list%20turning%20into%20an%20audio%20waveform%20with%20a%20tiny%20speaker%20character%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-3&orientation=landscape",
    tags: ["评论区", "配音", "神回复"],
    author: "神评收集官",
    date: "2026-09-04",
    views: 69870,
    likes: 4920,
    commentCount: 298,
    body: [
      "有些神回复用眼睛看已经很好笑了，配上一本正经的语气念出来，效果直接翻倍。这条视频挑的都是站内评论区的热门回复，句句自带节奏。",
      "最妙的是配乐：每念完一句都要停半秒，给观众一个笑的时间。作者说这叫「留白」，我倒觉得是给笑点留呼吸。",
    ],
  },
  {
    id: "video-4",
    category: "shipin",
    title: "让表情包动起来：静态图变身小动画",
    excerpt: "给捂脸笑加上抖动，给叹气猫加上云朵，一张图立刻有了生命。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20cute%20sticker%20characters%20jumping%20out%20of%20a%20video%20player%20frame%20with%20play%20buttons%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-4&orientation=landscape",
    tags: ["表情包", "动画", "二创"],
    author: "二创工作室",
    date: "2026-09-02",
    views: 55140,
    likes: 3860,
    commentCount: 214,
    body: [
      "把静态表情包做成小动画，其实用到的原理很简单：让关键元素按规律抖动、缩放、飘动。但就是这么简单的处理，让一张图从「能用」变成了「想反复看」。",
      "视频里展示了三组动效的制作思路，也分享了常用参数。评论区已经有小伙伴动手复刻，还做了一只摇头叹气猫，被顶到了热评。",
    ],
  },
  {
    id: "video-5",
    category: "shipin",
    title: "打工人 vlog 混剪：一整天只做三件事",
    excerpt: "上班、吃饭、等下班，被剪出了史诗感。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20video%20editing%20timeline%20with%20coffee%20cups%2C%20headphones%20and%20a%20laptop%20on%20a%20messy%20desk%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-5&orientation=landscape",
    tags: ["vlog", "混剪", "打工人"],
    author: "乐子研究所",
    date: "2026-08-31",
    views: 51280,
    likes: 3520,
    commentCount: 187,
    body: [
      "这条 vlog 混剪把「平凡的一天」剪出了电影感：清晨的闹钟、地铁的扶梯、工位上第一杯咖啡、傍晚的落日，全被配上大气的配乐，看起来像在完成一项伟大事业。",
      "最后字幕一出——「今天的主要成就：吃了三顿饭」——瞬间把史诗感拉回现实，评论区笑成一片。",
    ],
  },
  {
    id: "video-6",
    category: "shipin",
    title: "年度热梗盘点：这一年的快乐都在这里",
    excerpt: "二十个热梗一次看全，每个都能勾起一段回忆。",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20trophy%20made%20of%20speech%20bubbles%20with%20confetti%20and%20a%20film%20strip%20curling%20around%20it%2C%20warm%20coral%20orange%20golden%20yellow%20and%20cream%20palette%2C%20bold%20rounded%20flat%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=wg-video-6&orientation=landscape",
    tags: ["盘点", "热梗", "年度"],
    author: "吃瓜小分队",
    date: "2026-08-29",
    views: 73650,
    likes: 5210,
    commentCount: 341,
    body: [
      "年度盘点视频一口气整理了二十个热梗，从年初到年尾，每出现一个都会让人心里「哦，是那个」。这种回顾最妙的地方，是它会突然让你意识到：原来今年发生了这么多好笑的瞬间。",
      "作者把每个梗的来源和最佳使用场景都做了标注，适合收藏起来慢慢回味。评论区已经变成大型回忆现场，一条条补充着自己的年度关键词。",
    ],
  },
];